var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper reg-link-wrap"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0), _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap search-options gap-3 mb-3"
  }, [_c('div', {}, [_c('div', {
    staticClass: "d-flex align-items-stretch quick-filter-wrap"
  }, [_vm._m(1), _c('div', {
    staticClass: "dropdown-input-wrap position-relative flex-grow-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.email,
      expression: "filters.email"
    }],
    staticClass: "dropdown-input w-100 pe-5",
    attrs: {
      "type": "text",
      "placeholder": "Search Email"
    },
    domProps: {
      "value": _vm.filters.email
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.triggerSearch.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "email", $event.target.value);
      }
    }
  }), _c('i', {
    staticClass: "fa fa-search position-absolute text-muted",
    staticStyle: {
      "top": "50%",
      "right": "1rem",
      "transform": "translateY(-50%)",
      "pointer-events": "none"
    }
  })])])]), _c('div', {}, [_c('QuickDropdownFilter', {
    staticClass: "quick-dropdown-filter",
    attrs: {
      "modelValue": _vm.selectedStatus,
      "label": "Select Mail Status",
      "options": ['All', 'Queued', 'Sent', 'Invalid', 'Delivered', 'Opened', 'Bounced' ]
    },
    on: {
      "update:modelValue": _vm.onStatusChange
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center gap-2 quick-filter-wrap"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.send_date,
      expression: "send_date"
    }],
    staticClass: "quick-dropdown-filter p-2 h-100",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.send_date
    },
    on: {
      "change": _vm.onDateChange,
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.send_date = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "d-flex align-items-center gap-2 quick-filter-wrap"
  }, [_c('button', {
    staticClass: "quick-dropdown-filter clear-filter p-2 h-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.clearFilters();
      }
    }
  }, [_vm._v(" Clear Filters ")])])]), _c('div', {
    staticClass: "clientsData-wrap"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _c('tbody', [_vm.emailLogs.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No email logs found")])]) : _vm._e(), _vm._l(_vm.emailLogs, function (email) {
    return _c('tr', {
      key: email.id
    }, [_c('td', [_vm._v(_vm._s(email.id))]), _c('td', [_vm._v(" To : "), _c('span', {
      staticClass: "recipient"
    }, [_vm._v(_vm._s(email.to_email))]), _c('br'), _c('span', {
      class: ['status', email.status.toLowerCase() === 'invalid' ? 'failed' : email.status.toLowerCase()]
    }, [_vm._v(" " + _vm._s(email.status) + " ")])]), _c('td', [_c('b', [_vm._v("Subject:")]), _vm._v(" " + _vm._s(email.subject) + " "), _c('br')]), _c('td', [_vm._v(_vm._s(email.created_at))]), _c('td', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "d-flex gap-2"
    }, [_c('div', {
      staticClass: "mr-2"
    }, [_c('b-button', {
      staticClass: "p-0 text-decoration-none",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.openViewDetailsModal(email.id);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])], 1), _c('div', [_c('b-button', {
      staticClass: "p-0 text-decoration-none",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.openForwardEmailModal(email.id);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share"
    })])], 1)])])]);
  })], 2)])]), _c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filters
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)]), _c('ViewDetails', {
    attrs: {
      "show": _vm.showViewDetailsModal,
      "emailId": _vm.propData
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showViewDetailsModal = $event;
      }
    }
  }), _c('ForwardEmail', {
    attrs: {
      "show": _vm.showForwardEmailModal,
      "emailId": _vm.forwardPropData
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showForwardEmailModal = $event;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title emp-grp-title"
  }, [_c('div', {
    staticClass: "grp-title"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Email Log")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label-dropdown position-relative"
  }, [_c('button', {
    staticClass: "text-capitalize",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Email")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {}, [_c('strong', [_vm._v(" Sent Date ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _c('th', [_vm._v("Recipients")]), _c('th', [_vm._v("Email Details")]), _c('th', [_vm._v("Sent Date")]), _c('th', [_vm._v("Action")])])]);
}]

export { render, staticRenderFns }